import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "click",
  "use": "click-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"click\"><path fill-rule=\"evenodd\" d=\"M9.5 2a.5.5 0 0 1 .5.5v5.792l4.096-4.095a.5.5 0 0 1 .707.707l-4.096 4.095L16.5 9a.5.5 0 1 1 0 1l-5.794-.001 4.097 4.097a.5.5 0 0 1-.707.707L10 10.707V16.5a.5.5 0 1 1-1 0v-5.794l-4.096 4.097a.5.5 0 0 1-.707-.707L8.292 10H2.5a.5.5 0 0 1 0-1h5.793L4.197 4.904a.5.5 0 0 1 .707-.707L9 8.293V2.5a.5.5 0 0 1 .5-.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol